import React from 'react';

const Landing = () => (
  <div className={'text-center'} style={{ height: '1000px' }}>
    <h1>Какой-то контент лендинга...</h1>
  </div>
);

export default Landing;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/Landing/Landing.js